import { NGXLogger as LoggerService } from "ngx-logger";

import { AuthService } from "../../user/auth.service";
import { BannerInterface } from "./banner.interface";
import { TranslationGeneralService } from "../translation/translation.general.service";
import { NavigationService } from "../../whoo/core/navigation.service";

/**
 * Banner for anonymous users (every route the app shell shows the banner on: My Events, template choice,
 * poll-responses, poll-matrix ...): one true sentence - switching the browser loses the events - and one
 * way out, "Sign up". Since workorder poll-scoped access 1.11 there is no "Save my access" button any
 * more: a link for all events of the session does not exist in phase 1 (the bundle link is phase 2,
 * concept §5.6), and per event the organizer link sits behind the key icon of the context bar, the
 * answer link on the answer page.
 */
export class AnonymousBanner implements BannerInterface {
    public priority = 101;
    public message: string;
    rightButtonLabel: string;
    constructor(
        private logger: LoggerService,
        private authService: AuthService,
        private trans: TranslationGeneralService,
        private navigationService: NavigationService,
    ) {
        this.logger.log('AnonymousBanner');
        this.message = this.trans.translate('anonymousBanner.message')
        this.rightButtonLabel = this.trans.translate('anonymousBanner.rightButtonLabel')
    }

    getShowBanner(): boolean {
        return this.authService.isAnonymous
    }

    public handleLeftButtonClick() {
        // no left button (the banner component hides it without a label, like the sample banner)
    }

    public handleRightButtonClick() {
        this.navigationService.navigate(this.trans.getRoutePath('upgradeAnonymous'))
    }
}
